import styled from "@emotion/styled";
import { datePickerTheme } from "./datePickerTheme";
export const DatePickerDialogStyled = styled("div")`
    display: flex;
    flex-direction: column;
    align-items: stretch;

    box-sizing: border-box;
    ${_ref => {
  let {
    themeMode
  } = _ref;
  return `
        background: ${datePickerTheme.backgroundColor(themeMode)};
        box-shadow: ${datePickerTheme.boxShadow(themeMode)};
        border-radius: ${datePickerTheme.borderRadius(themeMode)};
        padding: ${datePickerTheme.padding(themeMode)};
    `;
}}
`;
//# sourceMappingURL=DatePickerDialogStyled.js.map